import type { TI_ListData } from '@stratumn/studio-shared';

//? selectedVariable is set in the component on spawn using the selectedVariableRef from the block datInfo
export const initialTIListData: Omit<TI_ListData, 'selectedVariable'> = {
  title: 'Default List Title'
};
